import { GetTonePriceDetailsDto } from './gettonepricedetailsdto';

export interface GetTonePriceDto
{
    getServiceId(): string;
    getAPartyMsisdn(): string;
    getToneId(): string;
    getBPartyMsisdnList(): string;
    getValidationIdentifier(): string;
    getLanguage(): string;
    getChannelId(): string;
    getPackName(): string;
    getIsDiyTone(): string;
    getToneDetailsList(): GetTonePriceDetailsDto[];
}

export class GetTonePriceDtoImpl implements GetTonePriceDto
{
    private serviceId: string;
    private aPartyMsisdn: string;
    private toneId: string;
    private bPartyMsisdnList: string;
    private validationIdentifier: string;
    private language: string;
    private channelId: string;
    private packName: string;
    private isDiyTone: string;
    private toneDetailsList: GetTonePriceDetailsDto[];
  

    getServiceId(): string 
    {
        return this.serviceId;
    }
    setServiceId(serviceId: string)
    {
        this.serviceId = serviceId;
    }

    getAPartyMsisdn(): string 
    {
        return this.aPartyMsisdn;
    }
    setAPartyMsisdn(aPartyMsisdn: string)
    {
        this.aPartyMsisdn = aPartyMsisdn;
    }

    getToneId(): string 
    {
        return this.toneId;
    }
    setToneId(toneId: string)
    {
        this.toneId = toneId;
    }
 

    getBPartyMsisdnList(): string 
    {
        return this.bPartyMsisdnList;
    }
    setBPartyMsisdnList(bPartyMsisdnList: string)
    {
        this.bPartyMsisdnList = bPartyMsisdnList;
    }
    
    getValidationIdentifier(): string 
    {
        return this.validationIdentifier;
    }
    setValidationIdentifier(validationIdentifier: string)
    {
        this.validationIdentifier = validationIdentifier;
    }

    getLanguage(): string 
    {
        return this.language;
    }
    setLanguage(language: string)
    {
        this.language = language;
    }

    getChannelId(): string 
    {
        return this.channelId;
    }
    setChannelId(channelId: string)
    {
        this.channelId = channelId;
    }

    getPackName(): string 
    {
        return this.packName;
    }
    setPackName(packName: string)
    {
        this.packName = packName;
    }

    getIsDiyTone(): string 
    {
        return this.isDiyTone;
    }
    setIsDiyTone(isDiyTone: string)
    {
        this.isDiyTone = isDiyTone;
    }

    getToneDetailsList(): GetTonePriceDetailsDto[]
    {
        return this.toneDetailsList;
    }
    setToneDetailsList(toneDetailsList: GetTonePriceDetailsDto[])
    {
        this.toneDetailsList = toneDetailsList;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/gettoneprice/gettonepricedto.tsx